import React, { forwardRef, useState } from 'react';

import {
  autoUpdate,
  offset,
  shift,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from '@floating-ui/react';
import { Preview, PreviewProvider } from '../components/preview';

const TestPopup = forwardRef<
  HTMLCanvasElement,
  { children: (isOpen: boolean) => React.ReactNode }
>(({ children }, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(10), shift()],
    whileElementsMounted: autoUpdate,
  });
  const click = useClick(context);
  const dismiss = useDismiss(context);
  const role = useRole(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
    role,
  ]);
  return (
    <>
      <button ref={refs.setReference} {...getReferenceProps()} type='button'>
        Open
      </button>
      <div
        ref={refs.setFloating}
        {...getFloatingProps()}
        style={{
          ...floatingStyles,
          visibility: isOpen ? 'visible' : 'hidden',
        }}
      >
        {children(isOpen)}
      </div>
      <p>some text to check this is not messing with layout</p>
    </>
  );
});
TestPopup.displayName = 'PreviewTestPopup';

const PreviewTestPage = () => {
  const [show, setShow] = useState(false);
  return (
    <PreviewProvider>
      <Preview id='HT068_1325380341_Feb2019_YEo22BxqqzW' />
      <button onClick={() => setShow(!show)} type='button'>
        show
      </button>
      {show ? <Preview id='HT068_1325380341_Feb2019_YEo22BxqqzW' /> : null}
      {/* <TestPopup>
        {(isOpen) => (
          <Preview id='HT439_1611530593_Jan2021_r08EAxmOE4K' pause={!isOpen} />
        )}
      </TestPopup> */}
    </PreviewProvider>
  );
};

export default PreviewTestPage;
